<div class="header-flex">
  <div class="header">
    <app-icon name="envelope" size="medium"></app-icon>
    <h3 translate>outgoing_messages</h3>
  </div>
  <div *ngIf="!(selectedBatch$ | async)" class="status-filter">
    <app-segmented-controls
      [controls]="statusFilters"
      [active]="status"
      (change)="changeStatus($event)"
    ></app-segmented-controls>
  </div>
</div>

<div class="widget-container">
  <ng-container *ngIf="preview$ | async as preview; else receiversOrBatches">
    <div class="layer-header">
      <span class="truncate">
        {{ preview.receiver.firstName }} {{ preview.receiver.familyName }}
      </span>
      <button
        type="button"
        class="btn btn-default btn-sm"
        (click)="closePreview()"
        translate
      >
        close
      </button>
    </div>
    <div
      *ngIf="preview.receiver.messageType === 'sms'; else emailPreview"
      class="sms-preview"
    >
      {{ preview.content }}
    </div>
    <ng-template #emailPreview>
      <iframe
        #previewFrame
        class="email-preview"
        sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </ng-template>
  </ng-container>

  <ng-template #receiversOrBatches>
    <ng-container *ngIf="selectedBatch$ | async as batch; else batchList">
      <div class="layer-header">
        <button
          type="button"
          class="btn btn-link btn-back"
          (click)="closeBatch()"
        >
          <app-icon name="chevron-left" size="small"></app-icon>
          <span translate>back</span>
        </button>
        <span class="truncate">{{ batch.activityName }}</span>
      </div>
      <ul
        class="list"
        [class.loading-pulse]="
          (receiversLoading$ | async) || (previewLoading$ | async)
        "
      >
        <li *ngFor="let receiver of receivers$ | async">
          <button
            type="button"
            class="list-item"
            (click)="openPreview(receiver)"
          >
            <app-icon name="user" size="small"></app-icon>
            <span class="truncate">
              {{ receiver.firstName }} {{ receiver.familyName }}
            </span>
          </button>
        </li>
      </ul>
      <list-item-empty *ngIf="(receivers$ | async)?.length === 0">
        <span *ngIf="!(receiversLoading$ | async); else spinner" translate>
          no_data_available_for_list
        </span>
      </list-item-empty>
      <div
        *ngIf="(receivers$ | async)?.length < (receiversTotal$ | async)"
        class="btn-more-container"
      >
        <button
          type="button"
          class="btn-more"
          (click)="loadMoreReceivers()"
          translate
        >
          show_more
        </button>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #batchList>
    <ul class="list" [class.loading-pulse]="batchesLoading$ | async">
      <li *ngFor="let batch of batches$ | async">
        <button
          type="button"
          class="list-item list-item--batch"
          (click)="openBatch(batch)"
        >
          <app-icon [name]="getIcon(batch)" size="medium"></app-icon>
          <span class="batch-info">
            <span class="truncate">{{ batch.activityName }}</span>
            <small>
              {{
                (status === "sent"
                  ? "outgoing_mail_sent_notice"
                  : "outgoing_mail_notice"
                )
                  | translate
                    : {
                        fromNow: getTimeFromNow(batch),
                        count: batch.numberOfPreGeneratedReceivers
                      }
              }}
            </small>
          </span>
          <span *ngIf="batch.messageType" class="message-type">
            {{ batch.messageType | translate }}
          </span>
        </button>
      </li>
    </ul>
    <list-item-empty *ngIf="(batches$ | async)?.length === 0">
      <span *ngIf="!(batchesLoading$ | async); else spinner" translate>
        no_outgoing_mails
      </span>
    </list-item-empty>
  </ng-template>
</div>

<ng-template #spinner>
  <spinner [size]="'1.2rem'"></spinner>
</ng-template>
